import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdPlayArrow } from 'react-icons/md';

const Play: React.FC<IconBaseProps> = (props) => <MdPlayArrow {...props} />;

export default Play;
